import React from 'react';
import './CustomDatePicker.css';
import DatePicker from 'react-datepicker';

const CustomDatePicker = ({
  value,
  onChange,
  error,
  dateFormat,
  placeholderText,
  showMonthYearPicker,
  disabled = false,
  showIcon = true,
  className,
  style,
  wrapperClassName,
  inputClassName,
  calendarClassName,
  ...props
}) => {
  return (
    <div className={wrapperClassName}>
      <DatePicker
        {...props}
        showIcon={showIcon}
        toggleCalendarOnIconClick
        className={`${disabled ? "ao-custom-dataPicker-disabled" : 'ao-custom-dataPicker'} ${inputClassName} ${className}`}
        placeholderText={placeholderText}
        selected={value}
        onChange={onChange}
        dateFormat={dateFormat}
        showMonthYearPicker={showMonthYearPicker}
        disabled={disabled}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        calendarClassName={calendarClassName}
        style={style}
      />
      {error && <div className='text-danger'>{error}</div>}
    </div>
  );
};

export default CustomDatePicker;    